import { BlotterTableWrapper, MarketDataCardPlaceholderWrapper, Stack } from '@talos/kyoko';
import { WatchListWrapper } from '@talos/kyoko/src/components/Watchlist/styles';
import styled from 'styled-components';
import { BOTTOM_SCROLL_GRADIENT_HEIGHT } from '../../../../components/Mobile/styles';

export const ScrollContainer = styled(Stack)`
  flex: 1;
  min-height: 0;
  overflow: auto;
  max-height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  max-height: 100dvh;
`;

export const CardsList = styled(Stack)`
  gap: 1px;
`;

export const CardRow = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundBody};
  padding-bottom: ${({ theme }) => theme.spacing16}px;
`;

export const MobileCardPlaceholderWrapper = styled(MarketDataCardPlaceholderWrapper)`
  height: 120px;
  width: 100%;
  border: none;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacing8}px;
`;

export const MobileWatchListStylesWrapper = styled.div`
  flex: 1;

  ${BlotterTableWrapper} {
    padding: 0px;

    .ag-center-cols-viewport {
      margin-bottom: ${BOTTOM_SCROLL_GRADIENT_HEIGHT}px;
    }
  }

  ${WatchListWrapper} {
    padding-top: 0;
  }
`;
